import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin-top: 80px;
    position: relative;
    z-index: 3;

    .menu-bars {
      margin-left: 8rem;
      font-size: 2rem;
      background: none;
      position: absolute;
      top: -58px;
      left: -10px;

      .menu {
        background: transparent;
        border-radius: 0.2rem;
        color: ${theme.colors.primary};
        height: 40px;
        width: 40px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid transparent;
        transition: 0.1s;
        top: 22px;
        cursor: pointer;
        position: fixed;
        z-index: 3;

        ::after {
          content: '';
          display: block;
          width: 1.2rem;
          height: 2px;
          border-radius: 2px;
          background: currentColor;
          box-shadow: 0 6px currentColor, 0 -6px currentColor;
          transition: 0.2s;
        }
      }
    }

    .overlay {
      position: fixed;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: 2;
    }

    .nav-menu {
      background: ${theme.colors.secondary};
      height: calc(100vh - 80px);
      width: 81px;
      display: flex;
      flex-direction: column;
      position: fixed;
      /* transition: 850ms; */
      top: 80px;
      overflow: auto;
      ::-webkit-scrollbar {
        width: 1px;
      }
      ::-webkit-scrollbar-thumb {
        background: ${theme.colors.secondary};
        border-radius: 10px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: ${theme.colors.secondary};
      }
      cursor: pointer;
      z-index: 2;

      .nav-content {
        width: 100%;
        color: ${theme.colors.white};
        font-family: ${theme.font.montserrat};
        font-size: ${theme.font.sizes.xxxsmall};
        font-weight: ${theme.font.semiBold};
        margin-top: 20px;
        padding: 16px 28px;

        a {
          text-decoration: none;
          color: ${theme.colors.white};
          align-items: center;
          display: flex;
          transition: ${theme.transition.default};
          position: relative;

          :hover {
            filter: brightness(0.8);
          }

          .icon-arrow-left {
            transition: ${theme.transition.default};
            position: absolute;
            right: 0;
          }
        }

        .dropdown-menu-content {
          a {
            padding: 21px 0 4px 38px;
          }
        }

        .sidebar-icon {
          margin-left: 0;
        }

        span {
          margin-left: 16px;
        }

        .dropdown-menu-content {
          overflow: hidden;
          height: 0;
        }

        &.dropActive {
          background: ${theme.colors.primary};
          height: unset;

          .dropdown-menu-content {
            height: auto;
          }

          .icon-arrow-left {
            transform: rotate(-90deg);
          }
        }
      }
      &.active {
        width: 263px;
        transition: 850ms;
      }
    }

    .nav-menu.active .dropdown {
      margin-top: 20px;
      transition: ${theme.transition.default};

      :hover {
        filter: brightness(0.8);
      }
    }

    ${media.lessThan('small')`
      .nav-menu.active{
        width: 100%;
      }

      .menu-bars{
        left: -42px;
      }
    `}
  `}
`
